export function getMinHeight() {
    return 'height:' + (window.screen.availHeight - 160) + 'px;max-height:' + (window.screen.availHeight - 160) + 'px;overflow:auto';
}

export function getMapHeight() {
    return 'height:' + (window.screen.availHeight - 210) + 'px;'
}


export const modalBodyStyle = {
    'max-height': '70vh',
    'min-height': '70vh',
    'overflow': 'auto'
};

/**
 * 获取随机颜色
 * @returns {string}
 */
export function getRandomColor() {
    return '#' + (Math.random() * 0xffffff << 0).toString(16);
}

/**
 * 获取年月日
 * @returns {string}
 */
export function getNowDateString() {
    let date = new Date();//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    return Y + '-' + M + '-' + D
}